import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { EngagementInsigtsService } from 'src/app/engagement-insights/engagement-insights.service';
import { ToastrService } from '@kpmg-tax/ui';
import { Messages } from '../../constants/messages';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { BaseResponse } from '../../models/base-response.model';
import { ExpenseSurveyComment, ExpenseSurveyCommentRequestDTO } from 'src/app/shared/models/expense-survey';
import { encodeText } from 'src/app/shared/lib/custom-tools';
import { ExpenseSurveyData } from 'src/app/survey-insight/expense-survey/models/expense-survey-details.model';
@Component({
  selector: 'expense-survey-comment',
  templateUrl: './expense-survey-comment.component.html',
  styleUrls: ['./expense-survey-comment.component.scss']
})
export class ExpenseSurveyCommentComponent implements OnInit {
  targetForm: FormGroup;
  comments: ExpenseSurveyComment[];
  isDisabled: boolean = false;
  resolvedStatus: boolean = false;
  surveyDetails: ExpenseSurveyData = {} as ExpenseSurveyData;
  constructor(
    public rightSideDrawerService: RightSideDrawerService,
    private formBuilder: FormBuilder,
    private _engagementService: EngagementInsigtsService,
    public toastrService: ToastrService) { }

  ngOnInit(): void {
    this.surveyDetails = this.rightSideDrawerService.singleRowEditData;
    this.getComments(this.surveyDetails.studyId, this.surveyDetails.surveyId);
    this.resetRightSideDrawerData();
  }
  resetRightSideDrawerData = () => {
    this.targetForm = this.formBuilder.group({
      comment: ['', [Validators.required, Validators.maxLength(3000)]]
    });

  }
  getComments(engagementId, surveyId) {
    this._engagementService.getExpenseSurveysComment(engagementId, surveyId).subscribe((result: BaseResponse) => {
      if (result.success) {
        if (result.result.length > 0) {
          this.comments = result.result;
        }
      } else {
        this.toastrService.setErrorMessage('The comment could not retrieved. Please contact the application support team by clicking the envelope icon on the top right corner of your screen.');
      }
    });
  }
  trimSpecialChar(ctrl: any) {
    if (this.targetForm.get(ctrl).value) {
      this.targetForm.controls[ctrl].setValue(
        this.targetForm.get(ctrl).value.replace(/[^a-zA-Z0-9-()._/@, ]/g, ''),
      );
    }
  }
  onAddComment() {
    if (this.targetForm.get('comment').value !== '') {
      this.isDisabled = false;
      this.rightSideDrawerService.setMandatoryField(true, 'Comments');
    } else {
      this.isDisabled = true;
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
  }

  addComment() {
    this.isDisabled = true;
    let comment: ExpenseSurveyCommentRequestDTO = {
      surveyId: this.surveyDetails.surveyId,
      engagementId: this.surveyDetails.studyId,
      comments: encodeText(this.targetForm.get('comment').value)
    };
    this._engagementService.addExpenseSurveysComment(comment).subscribe((data: BaseResponse) => {
      if (data && data.success) {
        this.toastrService.setSuccessMessage(Messages.UPDATE_SUCCESS_MESSAGE);
        this._engagementService.refreshExpenseSurveyMessageCount(true);
        this.rightSideDrawerService.closeRightSideDrawer({ isAddCommentSuccess: true });
      } else {
        this.toastrService.setSuccessMessage(data.errorMessage);
      }
    });
  }
}
